import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { CwsA, CwsGrid, CwsGridCol, CwsGridRow, CwsP, CwsSection } from '../../cms-web-styleguide-exports'
import { getDigiData } from '../../selectors/selectors'

function Footer() {
  const { t } = useTranslation()
  const digiData = useSelector(getDigiData)
  const country = digiData?.website?.country || 'fi'

  return (
    <CwsSection variant="footer">
      <CwsSection backgroundColor="midnight" className="cws-py-xs" variant="div">
        <CwsGrid>
          <CwsGridRow justifyContent="space-between" noGutterVertical>
            <CwsGridCol>
              <CwsP color="white" hideSpacing style={{ fontSize: 14 }}>
                {t('footer.copyright', { year: new Date().getFullYear() })}
              </CwsP>
            </CwsGridCol>
            {country !== 'xz' && (
              <CwsGridCol col="auto">
                <CwsA
                  aria-label={t('accessibility.icon.aria-label')}
                  href={t('accessibility.url')}
                  style={{ fontSize: 14 }}
                  target="_blank"
                  theme="midnight"
                >
                  {t('accessibility')}
                </CwsA>
              </CwsGridCol>
            )}
          </CwsGridRow>
        </CwsGrid>
      </CwsSection>
    </CwsSection>
  )
}

export default Footer
